module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiMobile-3bbb2207f94f0f050a2b3f777bbc374f.png";